import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';
import RcClickAway from 'react-click-away-listener';

import { ClickAwayListenerProps } from './interfaces';

const ClickAwayListener: FC<PropsWithChildren<ClickAwayListenerProps>> = ({
  onClickAway,
  children,
  className,
}) => (
  <RcClickAway mouseEvent="mousedown" onClickAway={() => onClickAway?.()}>
    <div className={classNames('clickAwayListener', className)}>{children}</div>
  </RcClickAway>
);

export default ClickAwayListener;
